import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimal',
    standalone: false
})
export class DecimalPipe implements PipeTransform {
  transform(value: number): string {
    // Round the value to 2 decimal places
    const roundedValue = value.toFixed(2);

    // Remove trailing zeros
    const trimmedValue = parseFloat(roundedValue).toString();

    return trimmedValue;
  }
}
